import { Injectable } from '@angular/core';
import { Observable, Subject, shareReplay, startWith, switchMap } from 'rxjs';
import { Site } from '../../models/site';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Logger } from '../logger.service';

const log = new Logger('SiteService');

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private _refreshTrigger$ = new Subject();
  private _sites$: Observable<Site[]>;

  constructor(private httpClient: HttpClient) { 
    this._sites$ = this._refreshTrigger$.pipe(
      startWith(null as unknown),
      switchMap(() => {
        log.info('Getting list of sites');

        return this.httpClient.get<Site[]>(`${environment.apiBaseUrl}/sites`);
      }),
    shareReplay(1)
    );
  }

  public get sites$(): Observable<Site[]> {
    return this._sites$;
  }

  public triggerReload() {
    this._refreshTrigger$.next(null);
  }
}
